import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Academy.css';
import { Box, Button, Grid } from '@mui/material';

const Academy = () => {
  const { t } = useTranslation();

  return (
    <div className='academy' id='academies' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid container className='body'>
        <Grid container item xs={12} md={5} className='left' >
          <label className='mobile'>{t(`academy.label`)}</label>
          <h1 className='mobile'>{t(`academy.title`)}<span>{t(`academy.title3`)}</span></h1>
          <img className='image1' src={Images.tiim.academy} alt='academy' />
          <Box>
            <h2>{t(`academy.benefits`)}</h2>
            {
              t(`academy.benefitsList`).map((item, index) => (
                <Grid key={index} container flexDirection={'row'} gap={2} noWrap alignItems={'flex-start'}>
                  <img className='check' src={Images.icons.circleCheck2} alt={'check'} />
                  <h4 className='benefit'>{item}</h4>
                </Grid>
              ))
            }
          </Box>
        </Grid>
        <Grid container item xs={12} md={7} className='right' >
          <label className='desktop'>{t(`academy.label`)}</label>
          <h1 className='desktop'>{t(`academy.title`)}<span>{t(`academy.title2`)}</span></h1>
          <img className='image2' src={Images.tiim.academy2} alt='academy' />
          <h3>{t(`academy.subtitle`)}<img className='logo' src={Images.tiim.logoTiim} alt='tiim' /></h3>
          <pre>{t(`academy.description`)}</pre>
          <Button className='button' variant="contained" onClick={() => window.location.href = "/academy"}>
            {t(`academy.button`)}
          </Button>
        </Grid>
        <Grid className='desktop' container item xs={12} md={7} justifyContent={'center'} alignContent={'center'} mt={'115px'}>
          <img className='payment' src={Images.tiim.payment} alt='payment' />
        </Grid>
        <Grid container item xs={12} md={5} justifyContent={'center'} alignContent={'center'} flexDirection={'column'}  mt={'115px'}>
          <p className='title'>{t(`academy.payment`)}</p>
          <img className='bank' src={Images.tiim.bank} alt='bank' />
          <p className='description'>{t(`academy.paymentDescription`)}</p>
          <img className='payment mobile' src={Images.tiim.payment} alt='payment' />
        </Grid>
      </Grid>
    </div>

  )
}

export default Academy 